import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const ArrowLeft = (props: IconProps = {}) => {
  const { ...rest } = props;

  return (
    <SvgIcon name="ArrowLeft" {...rest}>
      <path
        d="M8.51 19.021L1.5 12.01 8.51 5M2 12h22"
        stroke="currentColor"
        strokeWidth="2"
      />
    </SvgIcon>
  );
};
